import useSWR, { Fetcher } from 'swr'
import { client } from '~/api/client'
import { getFoldersFolderIdElementsV1, Schemas } from '~/api/gen'
import { assertSuccess } from '~/lib/assertSuccess'
import { FETCH_COUNT_PER_PAGE } from '../constants'
import { FilterType } from '../lib/filter'

type SwrKey = [
  key: 'getFoldersFolderIdElementsV1',
  folderId: number,
  pageNumber: number,
  filterType: FilterType,
]

const getFoldersFolderIdElementsV1Fetcher: Fetcher<
  Schemas.get_folders_folder_id_elements_v1_response,
  SwrKey
> = async ([_, folderId, pageNumber, filterType]) => {
  const result = await getFoldersFolderIdElementsV1(client, {
    parameter: {
      folder_id: folderId,
      pageno: pageNumber,
      pagesize: FETCH_COUNT_PER_PAGE,
      element_type: filterType,
    },
  })
  assertSuccess(result)

  return result.data
}

export const useFolderElements = (
  folderId: number,
  pageNumber: number,
  filterType: FilterType
) => {
  const res = useSWR<
    Schemas.get_folders_folder_id_elements_v1_response,
    Error,
    SwrKey
  >(
    ['getFoldersFolderIdElementsV1', folderId, pageNumber, filterType],
    getFoldersFolderIdElementsV1Fetcher
  )
  return res.data
}
